<template>
  <div
    ref="tooltipContent"
    @mouseover="show = true"
    @mouseleave="show = false"
    @click="onClick"
  >
    <Popup
      v-if="show"
      anchor="tooltipContent"
      :show="show"
      popup-class="header-popup-content"
    >
      {{ text }}
    </Popup>
    <slot> </slot>
  </div>
</template>

<script setup lang="ts">
import { Popup } from "@progress/kendo-vue-popup";
import { ref } from "vue";

const props = defineProps<{
  text: string;
  showOnClick?: boolean;
}>();

const show = ref(false);

const onClick = () => {
  if (props.showOnClick) {
    show.value = !show.value;
  }
};
</script>

<style lang="scss">
.header-popup-content {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
}
</style>
